import isElectron from 'is-electron';

export const isDesktop = (): boolean => {
  return isElectron();
};
